module.exports = __webpack_public_path__ + "img/create-class-icon.662f14ec.svg";